import translate from '@translate';
import { HistoryUpdatesItemType } from 'src/components/History/types';

export type EditKeysType =
    | 'ID'
    | 'ESHOP_KEY'
    | 'ESHOP_TRANSPORT_ID'
    | 'CREATED_AT'
    | 'SHIPPING_CREATED_AT'
    | 'ON_THE_WAY_AT'
    | 'DELIVERED_AT'
    | 'RETURNING_BACK_AT'
    | 'RETURNED_BACK_AT'
    | 'CANCELED_AT'
    | 'INCORRECT_AT'
    | 'LOST_AT'
    | 'UPDATED_AT'
    | 'EXECUTE_AT'
    | 'PICK_UP_AT'
    | 'BILLED_WEIGHT'
    | 'LAST_STATUS_CHECK_AT'
    | 'ID_CREATOR'
    | 'TYPE'
    | 'STATUS'
    | 'RECIPIENT_NAME'
    | 'RECIPIENT_ATTENTION_NAME'
    | 'RECIPIENT_EMAIL'
    | 'RECIPIENT_PHONE'
    | 'RECIPIENT_COMPANY_NAME'
    | 'RECIPIENT_COMPANY_ID'
    | 'RECIPIENT_TAX_ID'
    | 'RECIPIENT_STREET'
    | 'RECIPIENT_ADDRESS_ADDITIONAL_INFO'
    | 'RECIPIENT_ADDRESS_ADDITIONAL_INFO_2'
    | 'RECIPIENT_CITY'
    | 'RECIPIENT_STATE'
    | 'RECIPIENT_PROVINCE_CODE'
    | 'RECIPIENT_POST_CODE'
    | 'SENDER_NAME'
    | 'SENDER_ATTENTION_NAME'
    | 'SENDER_EMAIL'
    | 'SENDER_PHONE'
    | 'SENDER_COMPANY_NAME'
    | 'SENDER_COMPANY_ID'
    | 'SENDER_TAX_ID'
    | 'SENDER_STREET'
    | 'SENDER_ADDRESS_ADDITIONAL_INFO'
    | 'SENDER_ADDRESS_ADDITIONAL_INFO_2'
    | 'SENDER_CITY'
    | 'SENDER_STATE'
    | 'SENDER_PROVINCE_CODE'
    | 'SENDER_POST_CODE'
    | 'SHIPPER'
    | 'WEIGHT'
    | 'PRICE'
    | 'SHIPPING_PRICE'
    | 'CURRENCY'
    | 'SHIPPING_CURRENCY'
    | 'PAID'
    | 'PAYMENT_METHOD'
    | 'SHIPPER_SERVICE_CODE'
    | 'COD_PRICE'
    | 'COD_CURRENCY'
    | 'COD_REF_NUMBER'
    | 'MESSAGE'
    | 'INVOICE_NUMBER'
    | 'ADDRESS_ID'
    | 'INCORRECT_MESSAGE'
    | 'ORDER_BOX_COUNT'
    | 'SHIPMENT_PENDING'
    | 'TRANSPORT_PAID_BY_SKLADON'
    | 'AGECHECK'
    | 'RELEASE_FROM_SUSPENDED_AT'
    | 'TRACKING_NUMBER'
    | 'PACKAGES';

export const EDIT_KEYS = [
    'ID',
    'ESHOP_KEY',
    'ESHOP_TRANSPORT_ID',
    'CREATED_AT',
    'SHIPPING_CREATED_AT',
    'ON_THE_WAY_AT',
    'DELIVERED_AT',
    'RETURNING_BACK_AT',
    'RETURNED_BACK_AT',
    'CANCELED_AT',
    'INCORRECT_AT',
    'LOST_AT',
    'UPDATED_AT',
    'EXECUTE_AT',
    'PICK_UP_AT',
    'BILLED_WEIGHT',
    'LAST_STATUS_CHECK_AT',
    'ID_CREATOR',
    'TYPE',
    'STATUS',
    'RECIPIENT_NAME',
    'RECIPIENT_ATTENTION_NAME',
    'RECIPIENT_EMAIL',
    'RECIPIENT_PHONE',
    'RECIPIENT_COMPANY_NAME',
    'RECIPIENT_COMPANY_ID',
    'RECIPIENT_TAX_ID',
    'RECIPIENT_STREET',
    'RECIPIENT_ADDRESS_ADDITIONAL_INFO',
    'RECIPIENT_ADDRESS_ADDITIONAL_INFO_2',
    'RECIPIENT_CITY',
    'RECIPIENT_STATE',
    'RECIPIENT_PROVINCE_CODE',
    'RECIPIENT_POST_CODE',
    'SENDER_NAME',
    'SENDER_ATTENTION_NAME',
    'SENDER_EMAIL',
    'SENDER_PHONE',
    'SENDER_COMPANY_NAME',
    'SENDER_COMPANY_ID',
    'SENDER_TAX_ID',
    'SENDER_STREET',
    'SENDER_ADDRESS_ADDITIONAL_INFO',
    'SENDER_ADDRESS_ADDITIONAL_INFO_2',
    'SENDER_CITY',
    'SENDER_STATE',
    'SENDER_PROVINCE_CODE',
    'SENDER_POST_CODE',
    'SHIPPER',
    'WEIGHT',
    'PRICE',
    'SHIPPING_PRICE',
    'CURRENCY',
    'SHIPPING_CURRENCY',
    'PAID',
    'PAYMENT_METHOD',
    'SHIPPER_SERVICE_CODE',
    'COD_PRICE',
    'COD_CURRENCY',
    'COD_REF_NUMBER',
    'MESSAGE',
    'INVOICE_NUMBER',
    'ADDRESS_ID',
    'INCORRECT_MESSAGE',
    'ORDER_BOX_COUNT',
    'SHIPMENT_PENDING',
    'TRANSPORT_PAID_BY_SKLADON',
    'AGECHECK',
    'RELEASE_FROM_SUSPENDED_AT',
    'TRACKING_NUMBER',
    'PACKAGES',
];

export const INIT_TAB = 'transport';

export const historyUpdates: HistoryUpdatesItemType[] = [
    { key: 'STATUS', translateKey: 'transportDetail.transportStatus' },
    { key: 'INCORRECT_MESSAGE', translateKey: 'transportDetail.incorrectMessage' },
    { key: 'CREATED_AT', translateKey: 'transportDetail.created', format: 'date' },
    { key: 'LOST_AT', translateKey: 'transportDetail.losted', format: 'date' },
    { key: 'DELIVERED_AT', translateKey: 'transportDetail.delivered', format: 'date' },
    { key: 'INCORRECT_AT', translateKey: 'transportDetail.incorrected', format: 'date' },
    { key: 'ON_THE_WAY_AT', translateKey: 'transportDetail.onTheWayAt', format: 'date' },
    { key: 'PICK_UP_AT', translateKey: 'transportDetail.pickupDate', format: 'date' },
    { key: 'BILLED_WEIGHT', translateKey: 'transportDetail.billedWeight', format: 'number' },
    { key: 'EXECUTE_AT', translateKey: 'transportDetail.executeAt', format: 'date' },
    { key: 'RETURNED_BACK_AT', translateKey: 'transportDetail.returnedBackAt', format: 'date' },
    { key: 'RETURNING_BACK_AT', translateKey: 'transportDetail.returningBackAt', format: 'date' },
    { key: 'SHIPPING_CREATED_AT', translateKey: 'transportDetail.shippingCreatedAt', format: 'date' },
    { key: 'CANCELED_AT', translateKey: 'transportDetail.canceledAt', format: 'date' },
    { key: 'INVOICE_NUMBER', translateKey: 'transportDetail.invoiceNumber' },
    { key: 'PAYMENT_METHOD', translateKey: 'transportDetail.paymentMethod' },
    { key: 'PAID', translateKey: 'transportDetail.paid' },
    { key: 'PRICE', translateKey: 'transportDetail.invoicePrice', format: 'number' },
    { key: 'CURRENCY', translateKey: 'transportDetail.invoicePriceCurrency' },
    { key: 'SHIPPING_PRICE', translateKey: 'transportDetail.shippingPrice', format: 'number' },
    { key: 'SHIPPING_CURRENCY', translateKey: 'transportDetail.shippingPriceCurrency' },
    { key: 'COD_PRICE', translateKey: 'transportDetail.cashOnDeliveryPrice', format: 'number' },
    { key: 'COD_CURRENCY', translateKey: 'transportDetail.cashOnDeliveryCurrency' },
    { key: 'COD_REF_NUMBER', translateKey: 'transportDetail.cashOnDeliveryRefNumber' },
    { key: 'SHIPPER', translateKey: 'transportDetail.shipper' },
    { key: 'ADDRESS_ID', translateKey: 'transportDetail.dispensingPoint' },
    { key: 'SHIPPER_SERVICE_CODE', translateKey: 'transportDetail.shipperService' },
    { key: 'TRACKING_NUMBER', translateKey: 'transportDetail.trackingNumber' },
    { key: 'TRANSPORT_PAID_BY_SKLADON', translateKey: 'transportDetail.transportPaidBySkladon' },
    { key: 'ORDER_BOX_COUNT', translateKey: 'transportDetail.boxCount', format: 'number' },
    { key: 'SHIPMENT_PENDING', translateKey: 'transportDetail.shipmentPending' },
    { key: 'MESSAGE', translateKey: 'transportDetail.message' },
    { key: 'TYPE', translateKey: 'transportDetail.type' },
    { key: 'UNIT', translateKey: 'transportDetail.unit' },
    { key: 'AGECHECK', translateKey: 'transportDetail.agecheck' },
    { key: 'WEIGHT', translateKey: 'transportDetail.weight', format: 'number' },
    { key: 'RECIPIENT_NAME', translateKey: ['transportDetail.history.recipient', 'transportDetail.fullName'] },
    {
        key: 'RECIPIENT_ATTENTION_NAME',
        translateKey: ['transportDetail.history.recipient', 'transportDetail.attentionName'],
    },
    { key: 'RECIPIENT_STREET', translateKey: ['transportDetail.history.recipient', 'transportDetail.address'] },
    {
        key: 'RECIPIENT_ADDRESS_ADDITIONAL_INFO',
        translateKey: ['transportDetail.history.recipient', 'transportDetail.addressAdditionalInfo'],
    },
    {
        key: 'RECIPIENT_ADDRESS_ADDITIONAL_INFO_2',
        translateKey: ['transportDetail.history.recipient', 'transportDetail.additionalInformationForAddress2'],
    },
    { key: 'RECIPIENT_CITY', translateKey: ['transportDetail.history.recipient', 'transportDetail.city'] },
    { key: 'RECIPIENT_STATE', translateKey: ['transportDetail.history.recipient', 'transportDetail.country'] },
    {
        key: 'RECIPIENT_PROVINCE_CODE',
        translateKey: ['transportDetail.history.recipient', 'transportDetail.provinceCode'],
    },
    { key: 'RECIPIENT_POST_CODE', translateKey: ['transportDetail.history.recipient', 'transportDetail.postCode'] },
    { key: 'RECIPIENT_EMAIL', translateKey: ['transportDetail.history.recipient', 'transportDetail.email'] },
    { key: 'RECIPIENT_PHONE', translateKey: ['transportDetail.history.recipient', 'transportDetail.phone'] },
    {
        key: 'RECIPIENT_COMPANY_NAME',
        translateKey: ['transportDetail.history.recipient', 'transportDetail.companyName'],
    },
    { key: 'RECIPIENT_COMPANY_ID', translateKey: ['transportDetail.history.recipient', 'transportDetail.companyId'] },
    { key: 'RECIPIENT_TAX_ID', translateKey: ['transportDetail.history.recipient', 'transportDetail.taxId'] },
    { key: 'SENDER_NAME', translateKey: ['transportDetail.history.sender', 'transportDetail.fullName'] },
    {
        key: 'SENDER_ATTENTION_NAME',
        translateKey: ['transportDetail.history.sender', 'transportDetail.attentionName'],
    },
    { key: 'SENDER_STREET', translateKey: ['transportDetail.history.sender', 'transportDetail.address'] },
    {
        key: 'SENDER_ADDRESS_ADDITIONAL_INFO',
        translateKey: ['transportDetail.history.sender', 'transportDetail.addressAdditionalInfo'],
    },
    {
        key: 'SENDER_ADDRESS_ADDITIONAL_INFO_2',
        translateKey: ['transportDetail.history.sender', 'transportDetail.additionalInformationForAddress2'],
    },
    { key: 'SENDER_CITY', translateKey: ['transportDetail.history.sender', 'transportDetail.city'] },
    { key: 'SENDER_STATE', translateKey: ['transportDetail.history.sender', 'transportDetail.country'] },
    {
        key: 'SENDER_PROVINCE_CODE',
        translateKey: ['transportDetail.history.sender', 'transportDetail.provinceCode'],
    },
    { key: 'SENDER_POST_CODE', translateKey: ['transportDetail.history.sender', 'transportDetail.postCode'] },
    { key: 'SENDER_EMAIL', translateKey: ['transportDetail.history.sender', 'transportDetail.email'] },
    { key: 'SENDER_PHONE', translateKey: ['transportDetail.history.sender', 'transportDetail.phone'] },
    { key: 'SENDER_COMPANY_NAME', translateKey: ['transportDetail.history.sender', 'transportDetail.companyName'] },
    { key: 'SENDER_COMPANY_ID', translateKey: ['transportDetail.history.sender', 'transportDetail.companyId'] },
    { key: 'SENDER_TAX_ID', translateKey: ['transportDetail.history.sender', 'transportDetail.taxId'] },
];

export const historyUpdatesSkladonUser: HistoryUpdatesItemType[] = [
    ...historyUpdates,
    { key: 'UPDATED_AT', translateKey: 'transportDetail.updatedAt', format: 'date' },
    { key: 'LAST_STATUS_CHECK_AT', translateKey: 'transportDetail.lastStatusCheckAt', format: 'date' },
    { key: 'ID_CREATOR', translateKey: 'users.table.creatorId', format: 'number' },
    { key: 'ESHOP_KEY', translateKey: 'providerDetail.eshopKey' },
    { key: 'ESHOP_TRANSPORT_ID', translateKey: 'transportDetail.eshopTransportId' },
    { key: 'ID', translateKey: 'products.table.id', format: 'number' },
];

export const historyPackagesUpdates: HistoryUpdatesItemType[] = [
    { key: 'CREATED_AT', translateKey: 'transportDetail.created', format: 'date' },
    { key: 'SHIPPING_CREATED_AT', translateKey: 'transportDetail.shippingCreatedAt', format: 'date' },
    { key: 'LOST_AT', translateKey: 'transportDetail.losted', format: 'date' },
    { key: 'DELIVERED_AT', translateKey: 'transportDetail.delivered', format: 'date' },
    { key: 'INCORRECT_AT', translateKey: 'transportDetail.incorrected', format: 'date' },
    { key: 'ON_THE_WAY_AT', translateKey: 'transportDetail.onTheWayAt', format: 'date' },
    { key: 'PICK_UP_AT', translateKey: 'transportDetail.pickupDate', format: 'date' },
    { key: 'EXECUTE_AT', translateKey: 'transportDetail.executeAt', format: 'date' },
    { key: 'RETURNED_BACK_AT', translateKey: 'transportDetail.returnedBackAt', format: 'date' },
    { key: 'RETURNING_BACK_AT', translateKey: 'transportDetail.returningBackAt', format: 'date' },
    { key: 'CANCELED_AT', translateKey: 'transportDetail.canceledAt', format: 'date' },

    { key: 'STATUS', translateKey: 'transportDetail.packageTable.status' },
    { key: 'CURRENCY', translateKey: 'transportDetail.packageTable.currency' },
    { key: 'WAREHOUSE_TRACKING_NUMBER', translateKey: 'transportDetail.packageTable.warehouseTrackingNumber' },
    { key: 'WEIGHT', translateKey: 'transportDetail.packageTable.weight', format: 'number' },
    { key: 'WIDTH', translateKey: 'transportDetail.packageTable.width', format: 'number' },
    { key: 'HEIGHT', translateKey: 'transportDetail.packageTable.height', format: 'number' },
    { key: 'LENGTH', translateKey: 'transportDetail.packageTable.length', format: 'number' },
    { key: 'PRICE', translateKey: 'transportDetail.packageTable.price', format: 'number' },
    { key: 'EXPEDITION_BOX_NUMBER', translateKey: 'transportDetail.packageTable.boxNumber' },
    { key: 'PACKAGE_TYPE', translateKey: 'transportDetail.packageTable.packageType' },
    { key: 'VOLUME', translateKey: 'transportDetail.packageTable.volume', format: 'number' },
    { key: 'LOADING_METERS', translateKey: 'transportDetail.packageTable.loadingMeters', format: 'number' },
    { key: 'LINE_STATE', translateKey: 'transportDetail.packageTable.lineState' },
    { key: 'INCORRECT_MESSAGE', translateKey: 'transportDetail.incorrectMessage' },
];

export const statusesTo: { [key: string]: string[] } = {
    created: ['shippingCreated', 'canceled', 'incorrect'],
    shippingCreated: ['onTheWay', 'canceled', 'incorrect'],
    onTheWay: ['atPickupPoint', 'delivered', 'returningBack', 'canceled', 'incorrect', 'lost'],
    atPickupPoint: ['delivered', 'returningBack', 'canceled', 'incorrect', 'lost'],
    returningBack: ['returnedBack', 'lost', 'canceled'],
    returnedBack: ['canceled'],
    canceled: ['created', 'created'],
    incorrect: ['canceled'],
    lost: ['canceled'],
};

export const progressStepsCreate: { label: string; key: string }[] = [
    { label: translate('transportDetail.tab.transport'), key: 'transport' },
    { label: translate('transportDetail.tab.address'), key: 'address' },
    { label: translate('transportDetail.tab.packages'), key: 'packages' },
    { label: translate('transportDetail.tab.summary'), key: 'summary' },
];
export const progressSteps: { label: string; value: string }[] = [
    { value: 'transport', label: translate('transportDetail.tab.transport') },
    { value: 'address', label: translate('transportDetail.tab.address') },
    { value: 'packages', label: translate('transportDetail.tab.packages') },
    { value: 'history', label: translate('transportDetail.tab.history') },
    { value: 'apiCalls', label: translate('transportDetail.tab.apiCalls') },
    { value: 'events', label: translate('transportDetail.tab.events') },
];

export const STORAGE_KEY = 'transportEditData';
